import { PfSupport } from '../pf'

export const PjSupport = PfSupport
